/**
 * The row that tells the user a file was refused (PLT-6061).
 *
 * Rendered directly beneath the composer pill, on both surfaces that can take a
 * file: the chat composer (`UprightComposer`) and the launcher composer
 * (`LandingChatEntry`).
 *
 * Placement and colour are the design system's field-error rule, not a new
 * treatment: `design/60-ai-surface.md` maps the composer to a form field, and
 * `design/50-components.md` (Forms) puts a field's error message under the
 * field in `--color__red-500`. It is deliberately *not* the chat `.callout`
 * (that belongs to the message stream) and not a Primer `Banner` (that is a
 * section-level notice, and this is one control's validation message).
 *
 * `role="alert"` because the user just caused it by picking or pasting a file,
 * so it should be announced when it appears — the message is on screen only in
 * response to an action, never on load.
 */
import { useSyncExternalStore } from 'react';
import { getAttachmentNotices, subscribeAttachmentNotices } from './attachment-notices';

export function AttachmentNoticeRow() {
  const notices = useSyncExternalStore(subscribeAttachmentNotices, getAttachmentNotices, getAttachmentNotices);

  if (notices.length === 0) return null;

  return (
    <div className="upright-attachment-notice" role="alert">
      {notices.map((notice, index) => (
        // A multi-file pick can refuse two files with the same name (from
        // different folders), so the index is part of the key.
        <div key={`${index}-${notice}`} className="upright-attachment-notice-line">
          {notice}
        </div>
      ))}
    </div>
  );
}
